import React from 'react';
import './Home.css';
import Hero from '../../components/Hero/Hero';
import CaseStudies from '../CaseStudies/CaseStudies';
import SubscribeSection from '../../components/SubscribeSection/SubscribeSection';
import ContactCTA from '../../components/ContactCTA/ContactCTA';

const Home = () => {
  return (
    <div className="home">
      <Hero />
      <CaseStudies isHomePage={true} />
      <SubscribeSection />
      <ContactCTA />
    </div>
  );
};

export default Home; 